import React from 'react'

import ConversationListActionButton from '../../../atoms/ConvoListActionButton'

import { useQueueState } from '../../../../providers/QueueStateProvider'
import { useSocket } from '../../../../providers/SocketProvider'

import useStyles from './styles'

const AcceptRejectV2 = ({ conversation }) => {
  const {
    api: { denyConversationV2, acceptConversation: acceptConversationAPI }
  } = useSocket()
  const { session } = conversation
  const { handleClose, setAccepted, handleSelect } = useQueueState()

  const rejectConversation = React.useCallback(
    id => {
      handleClose(id, () => {
        denyConversationV2(id)
      })
    },
    [handleClose, denyConversationV2]
  )

  const acceptConversation = React.useCallback(
    async id => {
      await acceptConversationAPI(id)
      handleSelect(id)
    },
    [acceptConversationAPI, handleSelect]
  )

  const handleAcceptClick = React.useCallback(() => {
    setAccepted(true)
    acceptConversation(session)
  }, [setAccepted, session, acceptConversation])

  const handleRejectClick = React.useCallback(() => {
    rejectConversation(session)
  }, [session, rejectConversation])

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ConversationListActionButton
        variant='success'
        onClick={handleAcceptClick}
      >
        Accept
      </ConversationListActionButton>
      <ConversationListActionButton variant='error' onClick={handleRejectClick}>
        Decline
      </ConversationListActionButton>
    </div>
  )
}

export default AcceptRejectV2
